<div class="row">
    <div class="col-xs-7">
        <div class="discussion-container">
            <span
                *ngIf="discussions != null && discussions.length === 0"
                class="text-muted"
                >There are no messages on this mission yet.</span
            >
            <div class="discussion" *ngFor="let discussion of discussions">
                <div class="row">
                    <div class="message-sender">
                        <profile-picture
                            [personId]="discussion.sender.id"
                            [managingOrganisationId]="organisation.id"
                            [width]="30"
                            [height]="30"
                        >
                        </profile-picture>
                        <span class="header"
                            >Communication Sent at
                            {{
                                discussion.updatedAt
                                    | formatDateTime: mission.timeZone
                            }}
                            -
                            <span class="user-name"
                                >by {{ getName(discussion) }}</span
                            ></span
                        >
                    </div>
                    <div
                        class="message-body pre-wrap"
                        [textContent]="discussion.body"
                    ></div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xs-5" *ngIf="canSendMessage; else readOnly">
        <textarea
            id="new-message"
            class="form-control scrollbar"
            [(ngModel)]="message"
            rows="7"
            placeholder="Enter message"
        >
        </textarea>
        <button
            type="button"
            [disabled]="!message || isWorking"
            class="btn btn-primary btn-sm btn-send"
            (click)="sendMessage()"
        >
            <span
                [tooltip]="!message ? 'Enter a message above' : null"
                placement="top"
                >Send</span
            >
        </button>
    </div>
    <ng-template #readOnly>
        <div class="col-xs-5 text-muted">
            {{ readOnlyMessage }}
        </div>
    </ng-template>
</div>
